var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-anser-signature-template-container"},[_c('AscSignatureEmbedded',{attrs:{"plotly-data":_vm.getSignatureData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }